export const GAME_SAVE_STORAGE_KEY = 'minecraft_world_save_v1';
export const GAME_SAVE_VERSION = 1;

export function createSaveGameStore({
  storage = null,
  storageKey = GAME_SAVE_STORAGE_KEY
} = {}) {
  const resolvedStorage = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);

  function parseRaw(raw) {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (Number(parsed.version) !== GAME_SAVE_VERSION) return null;
      if (!parsed.data || typeof parsed.data !== 'object') return null;
      return parsed;
    } catch {
      return null;
    }
  }

  function read() {
    if (!resolvedStorage) return null;
    const raw = resolvedStorage.getItem(storageKey);
    return parseRaw(raw);
  }

  function write(data) {
    if (!resolvedStorage) return null;
    const payload = {
      version: GAME_SAVE_VERSION,
      savedAt: Date.now(),
      data: data && typeof data === 'object' ? data : {}
    };
    try {
      resolvedStorage.setItem(storageKey, JSON.stringify(payload));
      return payload;
    } catch {
      return null;
    }
  }

  function clear() {
    if (!resolvedStorage) return false;
    try {
      resolvedStorage.removeItem(storageKey);
      return true;
    } catch {
      return false;
    }
  }

  function getMeta() {
    const payload = read();
    if (!payload) return null;
    return {
      version: payload.version,
      savedAt: Number(payload.savedAt) || 0
    };
  }

  return {
    read,
    write,
    clear,
    getMeta
  };
}
